import AnimateButton from "src/components/Main/MainLayout/ui-component/extended/AnimateButton";
import LoadingButton from "@mui/lab/LoadingButton";
import { CSSProperties, ReactNode } from "react";

export interface LoadingButtonProps {
  loading: boolean;
  onSubmit: () => void;
  label: string;
  type?: "submit" | "button";
  disabled?: boolean;
  style?: CSSProperties;
  color?: "success" | "error" | "info" | "warning";
  variant?: "contained" | "outlined" | "text";
  size?: "small" | "medium" | "large";
  fullwidth?: boolean;
  startIcon?: ReactNode
}

export const CustomLoadingButton = ({
  loading,
  onSubmit,
  label,
  type = "button",
  disabled = false,
  style = {},
  color = "success",
  variant = "contained",
  size = "medium",
  fullwidth = true,
  startIcon,
}: LoadingButtonProps) => (
  <AnimateButton>
    <LoadingButton
      startIcon={startIcon}
      type={type}
      loading={loading}
      disabled={disabled}
      disableElevation
      fullWidth={fullwidth}
      size={size}
      variant={variant}
      color={color}
      onClick={onSubmit}
      style={style}
      sx={{
        textTransform: "none"
      }}
    >
      {label}
    </LoadingButton>
  </AnimateButton>
);
